import { render, staticRenderFns } from "./StockInDetail.vue?vue&type=template&id=b0e94694"
import script from "./StockInDetail.vue?vue&type=script&lang=js"
export * from "./StockInDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports